import React from "react";
import { TableWithAutosizedColumns as Table } from '~/ui/Table/Table2';
import cn from 'classnames';
import css from './css.css';


export const TableView = React.forwardRef((props, ref) => {
    let { tooltipsActive, tableSettingsTooltip, tableContainerClassName, ...otherProps } = props;
    let withTooltip = tooltipsActive && tableSettingsTooltip && tableSettingsTooltip.length > 0;

    return (
        <div className={cn(css.tableContainer, tableContainerClassName, {[css.withTooltip]:withTooltip})}>
            <Table
                ref={ ref }
                { ...otherProps }
                className={css.dataTable}
            />
        </div>
    )
});